// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timelinesection-inline-1 {
  padding: 16px;
  margin-bottom: 16px;
}

.timelinesection-inline-2 {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 10px;
}

.timelinesection-inline-3 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  font-size: 12px;
}

.timelinesection-inline-4 {
  color: #64748b;
}

.timelinesection-inline-5 {
  color: #64748b;
}

.timelinesection-inline-6 {
  color: #64748b;
}

.timelinesection-inline-7 {
  color: #64748b;
}

.timelinesection-inline-8 {
  color: #64748b;
}

.timelinesection-inline-9 {
  color: #64748b;
}

.timelinesection-inline-10 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.timelinesection-inline-11 {
  padding: 20px;
  text-align: center;
  color: #94a3b8;
}

.timelinesection-inline-12 {
  margin-bottom: 16px;
}

.timelinesection-inline-13 {
  font-size: 13px;
  font-weight: 700;
  color: #4f46e5;
  margin-bottom: 8px;
}

.timelinesection-inline-14 {
  padding: 14px;
  margin-bottom: 8px;
  border-left: 3px solid #4f46e5;
}

.timelinesection-inline-15 {
  font-weight: 600;
  font-size: 13px;
}

.timelinesection-inline-16 {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
}

.timelinesection-inline-17 {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/TimelineSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".timelinesection-inline-1 {\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.timelinesection-inline-2 {\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.timelinesection-inline-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.timelinesection-inline-4 {\n  color: #64748b;\n}\n\n.timelinesection-inline-5 {\n  color: #64748b;\n}\n\n.timelinesection-inline-6 {\n  color: #64748b;\n}\n\n.timelinesection-inline-7 {\n  color: #64748b;\n}\n\n.timelinesection-inline-8 {\n  color: #64748b;\n}\n\n.timelinesection-inline-9 {\n  color: #64748b;\n}\n\n.timelinesection-inline-10 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.timelinesection-inline-11 {\n  padding: 20px;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.timelinesection-inline-12 {\n  margin-bottom: 16px;\n}\n\n.timelinesection-inline-13 {\n  font-size: 13px;\n  font-weight: 700;\n  color: #4f46e5;\n  margin-bottom: 8px;\n}\n\n.timelinesection-inline-14 {\n  padding: 14px;\n  margin-bottom: 8px;\n  border-left: 3px solid #4f46e5;\n}\n\n.timelinesection-inline-15 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.timelinesection-inline-16 {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n.timelinesection-inline-17 {\n  font-size: 11px;\n  color: #94a3b8;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
